/* =========================================================
   Diesel PDP gallery zoom cursor — matches uk.diesel.com.

   A circular red (#e4002b) outline with a + inside follows the mouse while it
   is over the MAIN (centre) gallery image, hiding the default cursor there.
   Clicking the image opens the existing lightbox (the <modal-opener> / product
   modal) — this file does NOT build a new zoom, it only draws the cursor.

   - Desktop / fine-pointer only: bails on touch (hover: none), so mobile is
     unaffected and tap-to-zoom via the lightbox still works.
   - Delegated on document, so it keeps working after a colour swap replaces
     <product-info> (the new centre image is matched by the same selector).
   - Scoped to the centre carousel image only — the arrows, play/pause and
     progress bar sit outside it, so hovering a control shows the normal pointer
     and the ring hides.
   ========================================================= */
(function () {
  'use strict';

  // No hover / coarse pointer (touch) -> do nothing at all.
  if (!window.matchMedia || !window.matchMedia('(hover: hover) and (pointer: fine)').matches) return;

  var SELECTOR = '.diesel-carousel .product__media-item.is-center';
  var ring = null;
  var hovering = null;
  var raf = 0;
  var x = 0;
  var y = 0;

  function build() {
    if (ring) return;
    ring = document.createElement('div');
    ring.className = 'dsl-zoom-cursor';
    ring.setAttribute('aria-hidden', 'true');
    ring.innerHTML =
      '<svg viewBox="0 0 48 48" aria-hidden="true" focusable="false">' +
      '<circle cx="24" cy="24" r="22.5" fill="#fff" stroke="currentColor" stroke-width="2.5"/>' +
      '<path d="M24 14.5v19M14.5 24h19" stroke="currentColor" stroke-width="2.5" stroke-linecap="round"/>' +
      '</svg>';
    document.body.appendChild(ring);
  }

  function paint() {
    raf = 0;
    if (ring) ring.style.transform = 'translate3d(' + x + 'px,' + y + 'px,0) translate(-50%,-50%)';
  }

  function wrapperOf(el) {
    return el.closest('.product__media-wrapper') || el.closest('.diesel-carousel') || el;
  }

  function enter(el) {
    build();
    if (hovering && hovering !== el) {
      hovering.classList.remove('dsl-zoom-hovering');
      wrapperOf(hovering).classList.remove('dsl-zoom-active');
    }
    hovering = el;
    el.classList.add('dsl-zoom-hovering');
    // Hide the native cursor across the WHOLE gallery while the ring is up, so
    // any control overlapping the image (play/pause, arrows) can't leak its
    // finger/pointer cursor alongside the ring.
    wrapperOf(el).classList.add('dsl-zoom-active');
    ring.classList.add('is-visible');
  }

  function leave() {
    if (hovering) {
      hovering.classList.remove('dsl-zoom-hovering');
      wrapperOf(hovering).classList.remove('dsl-zoom-active');
      hovering = null;
    }
    if (ring) ring.classList.remove('is-visible');
  }

  document.addEventListener(
    'mousemove',
    function (e) {
      var target = e.target && e.target.closest ? e.target.closest(SELECTOR) : null;
      if (target) {
        if (hovering !== target) enter(target);
        x = e.clientX;
        y = e.clientY;
        if (!raf) raf = requestAnimationFrame(paint);
      } else if (hovering) {
        leave();
      }
    },
    { passive: true }
  );

  // Scrolling doesn't fire mousemove, so with the pointer still the content
  // slides out from under the ring. Re-test the last pointer position on scroll
  // and hide the ring if the image is no longer beneath it.
  window.addEventListener(
    'scroll',
    function () {
      if (!hovering) return;
      var el = document.elementFromPoint(x, y);
      var still = el && el.closest ? el.closest(SELECTOR) : null;
      if (!still) leave();
    },
    { passive: true }
  );

  // Hide when the pointer leaves the window or the colour swap re-renders.
  window.addEventListener('blur', leave);
  document.addEventListener('dsl:swatch:swapped', leave);
})();
